import Collection from './collection.js';
import Integration from 'newModels/integration.js';

export default class Integrations extends Collection {
    url() {
        if (this.company) {
            return this.company.url() + '/integrations';
        }
        return '/Integrations';
    }

    initialize(models, {company = null}) {
        this.model = Integration;
        super.initialize(...arguments);
        this.company = company;
        return this;
    }
}



// WEBPACK FOOTER //
// ./app/new-collections/integrations.js